import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getForUserDateFrom(id:number, dateFrom:string, idCentre:number|null=null):Promise<UserHeure>{
    let params = `datTo=${dateFrom}`;
    if(idCentre){
        params+=`&Centre=${idCentre}`
    }
    const res:any = await dataFetcher(`user_heures/${id}?${params}`, {method:'get'})
    return res
}